import React from "react";
import IvorySection from "./Ivory";
import Whyivory from "./Why";
import Achievements from "../AchievementSlider";
import StatsNumbers from "./Ivorynumbers";
import Certificate from "./Ivorycertificate";
import Licenses from "./Licenses";
import ValuesSection from "../ValuesSection";

const AboutIvory = () => {
  return (
    <>
      <IvorySection />
      <ValuesSection />
      <Whyivory />
      <StatsNumbers />
      <Achievements />
      <Licenses />
      <Certificate />

    </>
  );
};

export default AboutIvory;
